import {
  MainClientsSection,
  MainHeroSection,
  MainServiceSection,
  MainStatsSection,
  MainStrengthSection,
} from "@/components/main";

const Main = () => {
  return (
    <main className="mt-[75px] bg-white">
      <MainHeroSection />
      <MainServiceSection />
      <MainStrengthSection />
      {/* <MainStatsSection /> */}
      <MainClientsSection />
    </main>
  );
};

export default Main;
